import { defineComponent as h, ref as f, computed as m, watchEffect as j, openBlock as i, createElementBlock as d, normalizeStyle as L, toDisplayString as S, createCommentVNode as y, createBlock as P, unref as v, useSlots as $, renderSlot as p, createElementVNode as w, withCtx as g, createVNode as _, createSlots as N, renderList as T } from "vue";
import E from "@patsnap-biz/list";
import H from "@patsnap-biz/header-dropdown";
import { onClickOutside as I } from "@vueuse/core";
import { UserCenterService as O } from "@patsnap-utils/biz";
import { useI18n as B } from "vue-i18n";
import D from "@patsnap-biz/icon";
import "@patsnap-ui/icon/assets/solid/users.svg";
import "@patsnap-ui/icon/assets/solid/settings.svg";
import "@patsnap-ui/icon/assets/solid/TranslateEnglish.svg";
import "@patsnap-ui/icon/assets/solid/logout.svg";
import "@patsnap-ui/icon/assets/solid/profile.svg";
import "@patsnap-ui/icon/assets/solid/DropdownRight.svg";
import "@patsnap-ui/icon/assets/solid/ChangeOrder.svg";
const F = {
  PtUserCenter: {
    login: "登录",
    logout: "登出",
    account: "用户设置",
    adminSettings: "管理员工作台",
    team: "团队",
    projectTimer: "项目计时",
    personal: "个人",
    enterprise: "企业"
  }
}, V = {
  PtUserCenter: {
    login: "Login",
    logout: "Logout",
    account: "Account",
    adminSettings: "Admin Settings",
    team: "Team",
    projectTimer: "Project Timer",
    personal: "Personal",
    enterprise: "Enterprise"
  }
}, x = {
  PtUserCenter: {
    login: "ログイン",
    logout: "ログアウト",
    account: "アカウント",
    adminSettings: "管理設定",
    team: "チーム",
    projectTimer: "タイマー",
    personal: "個人",
    enterprise: "企業"
  }
}, q = {
  PtUserCenter: {
    login: "登錄",
    logout: "登出",
    account: "用戶設置",
    adminSettings: "管理員工作臺",
    team: "團隊",
    projectTimer: "項目計時",
    language: "語言",
    personal: "個人",
    enterprise: "企業"
  }
}, G = { key: 0 }, J = /* @__PURE__ */ h({
  __name: "Avatar",
  props: {
    username: {
      type: String,
      default: ""
    },
    avatar: {
      type: String,
      default: ""
    },
    avatarColor: {
      type: [String, Number],
      default: ""
    }
  },
  setup(r) {
    const t = r, c = f(!1), a = f(!1), u = m(() => t.username.substring(0, 1).toUpperCase()), s = m(() => t.avatarColor ? `#${Number(t.avatarColor).toString(16)}` : "#F4F5F7"), b = m(() => !u.value && !t.avatar), C = () => {
      if (c.value = !1, a.value = !1, !t.avatar)
        return;
      const l = new Image();
      l.onload = () => {
        c.value = !0;
      }, l.onerror = () => {
        a.value = !0;
      }, l.src = t.avatar;
    };
    return j(() => {
      t.avatar && C();
    }), (l, k) => (i(), d("div", {
      class: "patsnap-biz-avatar",
      style: L({
        backgroundImage: `url(${r.avatar})`,
        backgroundSize: "contain",
        backgroundColor: s.value
      })
    }, [
      !c.value && !a.value && u.value ? (i(), d("span", G, S(u.value), 1)) : y("", !0),
      a.value || b.value ? (i(), P(v(D), {
        key: 1,
        class: "patsnap-biz-avatar__error",
        icon: "SolidProfile"
      })) : y("", !0)
    ], 4));
  }
}), K = { class: "patsnap-biz-user_center" }, M = {
  key: 0,
  class: "patsnap-biz-user_center--not-logged-in",
  flex: "-center"
}, Q = ["href"], R = /* @__PURE__ */ h({
  __name: "UserCenter",
  props: {
    service: {
      type: Object,
      default: () => new O()
    }
  },
  setup(r) {
    const t = r, c = $(), a = f(!1), u = m(() => {
      const e = ["default", "language"];
      return Object.keys(c).filter((o) => !e.includes(o));
    }), { t: s } = B({
      fallbackLocale: "cn",
      messages: {
        cn: F,
        en: V,
        jp: x,
        tw: q
      }
    }), b = m(
      () => t.service.items.map((e) => {
        if (e === null)
          return null;
        if (typeof e == "string")
          return s(e) ? s(e) : e;
        const {
          i18n: n,
          label: o,
          key: A,
          ...U
        } = e;
        return {
          label: n && s(n) ? s(n) : o || n,
          key: A,
          ...U
        };
      })
    );
    function C() {
      a.value = !a.value;
    }
    function l() {
      a.value = !1;
    }
    const k = f(null);
    I(k, l);
    function z(e) {
      if (t.service.beforeLogin) {
        e.preventDefault();
        const { loginHref: n, logoutHref: o } = t.service;
        t.service.beforeLogin({ loginHref: n, logoutHref: o });
      }
    }
    return (e, n) => (i(), d("div", K, [
      r.service.logged ? (i(), P(v(H), {
        key: 1,
        trigger: "hover",
        class: "patsnap-biz-user_center--logged"
      }, {
        reference: g(() => [
          _(J, {
            ref_key: "myPtAvatarElement",
            ref: k,
            username: r.service.name,
            avatar: r.service.avatar,
            "avatar-color": r.service.avatarColor,
            onClick: C
          }, null, 8, ["username", "avatar", "avatar-color"])
        ]),
        popper: g(() => [
          p(e.$slots, "header", { trigger: "hover" }),
          _(v(E), {
            class: "patsnap-biz-user_center_menu",
            items: b.value
          }, N({
            language: g(() => [
              p(e.$slots, "language", { trigger: "hover" })
            ]),
            _: 2
          }, [
            T(u.value, (o) => ({
              name: o,
              fn: g(() => [
                p(e.$slots, o)
              ])
            }))
          ]), 1032, ["items"])
        ]),
        _: 3
      })) : (i(), d("div", M, [
        p(e.$slots, "language"),
        w("a", {
          class: "pt-ui-btn patsnap-biz-user_center__btn",
          type: "primary",
          _target: "_self",
          href: r.service.logoutHref,
          onClick: z
        }, S(v(s)("PtUserCenter.login")), 9, Q)
      ]))
    ]));
  }
}), W = (r) => r, me = W(R);
export {
  me as PtUserCenter,
  me as default
};
